"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTotalCostOfOwnershipMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.createTotalCostOfOwnershipMutation = (0, graphql_tag_1.default) `
  mutation CreateTotalCostOfOwnership($input: CreateTotalCostOfOwnershipInputType!) {
    createTotalCostOfOwnership(inputs: $input) {
      id
      tcoId
      revisionNo
      tcoNo
    }
  }
`;
//# sourceMappingURL=create-total-cost-of-ownership.js.map